export const BASE_CLASS = 'mt-PanelFinancing'

export const FDA_GENERAL_ERROR = 'error'
export const FDA_USER_STOPPED_EXECUTION_ERROR = 'Execution stopped by user'
export const MODAL_CONTENT_IDS = {
  legalContent: 'legalContent',
  fdaLoading: 'fdaLoading',
  fdaError: 'fdaError'
}

export const MAX_RETRIES = 10
export const RETRY_INTERVAL = 1000

export const WITHOUT_DISCOUNT = 'withoutDiscount'
export const WITH_DISCOUNT = 'withDiscount'
export const WITH_DISCOUNT_AND_MAX_ENTRY_EXCEEDED = 'withDiscountAndMaxEntryToGetDiscountExceeded'
export const WITH_DISCOUNT_AND_MAX_ENTRY_NOT_EXCEEDED = 'withDiscountAndMaxEntryToGetDiscountNotExceeded'
export const NOT_APPLY = 'notApply'

export const IS_PRIVATE = 'isPrivate'

export const WITH_INSURANCE = 'withInsurance'
export const WITHOUT_INSURANCE = 'withoutInsurance'

export const PANEL_FINANCING_VERSION = {
  B2C: 'b2c',
  C2C: 'c2c',
  SIMPLIFIED: 'simplified'
}
